"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var icons_1 = require("../../icons");
var sizes_1 = require("../../icons/sizes");
var polished_1 = require("polished");
var ExternalLinkText = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n  text-decoration-color: currentColor;\n  text-decoration-thickness: ", ";\n  text-underline-offset: ", ";\n\n  &,\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"], ["\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n  text-decoration-color: currentColor;\n  text-decoration-thickness: ", ";\n  text-underline-offset: ", ";\n\n  &,\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), (0, polished_1.rem)(1.5), (0, polished_1.rem)(2), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.primary;
});
var ExternalLinkIcon = (0, styled_components_1.default)(icons_1.ExternalLink).attrs(function () { return ({
    primaryColor: 'currentColor',
    'aria-hidden': true,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n"])), function (_a) {
    var size = _a.size;
    return sizes_1.iconSizes[size];
}, function (_a) {
    var size = _a.size;
    return sizes_1.iconSizes[size];
}, (0, polished_1.rem)(4));
var ExternalLink = function (_a) {
    var children = _a.children, _b = _a.icon, icon = _b === void 0 ? sizes_1.IconSize.Medium : _b, props = __rest(_a, ["children", "icon"]);
    return (react_1.default.createElement(ExternalLinkText, __assign({}, props, { target: "_blank", rel: "noopener noreferrer" }),
        children,
        icon && react_1.default.createElement(ExternalLinkIcon, { size: icon })));
};
exports.ExternalLink = ExternalLink;
var templateObject_1, templateObject_2;
